import styled from 'styled-components'
import { mediaQueries } from 'plugins/device'

import { TextHeadline1, IconIllustrativeVerified, colors } from '@blocket/blocket-ui'

export const RowWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const UserProfileSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 0px 16px 0px;
  @media ${mediaQueries.medium} {
    max-width: 66%;
    padding: 24px 24px 16px 0px;
  }
`

export const UserInfoSection = styled.div`
  display: flex;
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0; /*fix for text-overflow: ellipsis; together with display flex*/
`

export const IllustrativeContainer = styled.div`
  margin-right: 12px;
  position: relative;
`

export const IconVerified = styled(IconIllustrativeVerified)`
  position: absolute;
  left: 40px;
  top: 40px;
`

export const Name = styled(TextHeadline1)`
  text-overflow: ellipsis;
  overflow-x: hidden;
  @media ${mediaQueries.medium} {
    max-width: none;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  min-height: 136px;
  width: 100%;
  max-width: 350px;
`

export const NamePlaceholder = styled.div`
  height: 32px;
  width: 165px;
  background: ${colors.grey100};
  margin-bottom: 8px;
`

export const AccountCreationDatePlaceholder = styled.div`
  height: 20px;
  width: 115px;
  background: ${colors.grey100};
  margin-bottom: 8px;
`

export const DataPlacerholder = styled.div`
  height: 32px;
  width: 200px;
  background: ${colors.grey100};
  margin-top: 18px;
`

export const AvatarPlacerholder = styled.div`
  margin-right: 12px;
  height: 64px;
  width: 64px;
  border-radius: 45%;
  background: ${colors.grey100};
`
